import * as React from 'react'
import { Button } from 'react-bootstrap'
import Form, { IChangeEvent, ISubmitEvent } from 'react-jsonschema-form'
import ActionsLocalService from '../Services/ActionsLocalService'
import HttpActionsService from '../Services/HttpActionsService'
import LocalizationStore from '../Stores/LocalizationStore'
import UserStore from '../Stores/UserStore'
import { Questionnaire, QuestionnaireStatus } from './Questionnaire'

export interface IAgentInfo {
    qId: string
    agentCode: string
    agentAction: string
}

export class AgentInfo {

    constructor(
        qId: string,
        agentCode: string,
        agentAction: string) {
        this.qId = qId
        this.agentCode = agentCode
        this.agentAction = agentAction
    }

    qId: string
    agentCode: string
    agentAction: string
}

export function getAgentInfoFormScheme(): any {
    const ls = LocalizationStore.getInstance()
    return {
        title: ls.t!('agentInfo'),
        type: 'object',
        required: [
            'qId'
        ],
        properties: {
            qId: {
                'title': ls.t!('qId'),
                'type': 'string',
                'maxLength': 100
            },
            agentCode: {
                title: ls.t!('agentCode'),
                type: 'string',
                maxLength: 100
            },
            agentAction: {
                title: ls.t!('agentAction'),
                type: 'string',
                maxLength: 100
            }
        }
    }
}

export function getAgentInfoFormUISchema(isReadonly: boolean) {

    return {
        qId: {
            'ui:widget': 'hidden'
        },
        agentCode: {
            'ui:readonly': isReadonly
        },
        agentAction: {
            'ui:readonly': isReadonly
        }
    }
}

export function onChange(e: IChangeEvent<IAgentInfo>) {
    ActionsLocalService.getInstance().updateAgentInfoInQ(e.formData)
}

export function onSubmit(e: ISubmitEvent<IAgentInfo>) {
    HttpActionsService.getInstance()
        .updateAgentInfo(e.formData)
}

export function checkCanSave(questionnaire: Questionnaire) {
    const userStore = UserStore.getInstance()

    return (
        questionnaire.id &&
        questionnaire.status &&
        questionnaire.status !== 0 &&
        questionnaire.status !== QuestionnaireStatus.Canceled &&
        (
            userStore.checkAdmin
            || userStore.checkSuperAdmin
            || userStore.checkCreditGroupAdministrator
            || userStore.checkCollectionGroupAdministrator
            || (
                userStore.id === questionnaire.inProgressByUserId
                && (
                    (userStore.checkCreditConsultant &&
                        questionnaire.status === QuestionnaireStatus.InProgressCreditConsultant)
                    || (userStore.checkCreditExpert &&
                        questionnaire.status === QuestionnaireStatus.InProgressCreditExpert)
                )
            )
        )
    )
}

export function getAgentInfoForm(questionnaire: Questionnaire) {
    const ls = LocalizationStore.getInstance()
    let isReadonly = !checkCanSave(questionnaire)
    return (
        <Form
            schema={getAgentInfoFormScheme()}
            uiSchema={getAgentInfoFormUISchema(isReadonly && !!questionnaire.id)}
            onSubmit={onSubmit}
            formData={new AgentInfo(questionnaire.id, questionnaire.agentCode, questionnaire.agentAction)}
            onChange={onChange}
        >
            <div
                className="questionnaireBtns"
                hidden={isReadonly}
            >
                <Button
                    className="w-100"
                    type="submit"
                >
                    {ls!.t!('Save')}
                </Button>
            </div>
        </Form >
    )
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Model/AgentInfo.tsx